import * as React from 'react';
import { AppNavLink } from 'src/models/Utility/AppNavLink';
import { SidebarLayout } from '../utility/components/SidebarLayout';

const UserNavLinks: AppNavLink[] = [
    { text: "User Profile", path: "/user/profile" },
];

export function UserManager(): JSX.Element {
    return (
        <SidebarLayout links={UserNavLinks} />
    );
}
